import { useState } from "react";
import { Card } from "../card";
import { Flex, Text } from "@chakra-ui/react";
import { ImageFragment } from "@ui/post";

export interface HoverCardProps {
  label: string;
  description: string;
  bg: string;
  textColor: string;
  icon?: ImageFragment & {
    alt: string;
  };
}

export const HoverCard = ({
  label,
  description,
  bg,
  textColor,
}: HoverCardProps) => {
  const [onHover, setOnHover] = useState(false);
  return (
    <Card
      height={{
        lg: "200px",
        xl: "250px",
      }}
      w={"full"}
      bgColor={bg}
      onMouseEnter={() => setOnHover(true)}
      onMouseLeave={() => setOnHover(false)}
      borderRadius={"3xl"}
      shadow={"lg"}
    >
      <Flex
        alignItems={"center"}
        justifyContent={"center"}
        h="full"
        px={6}
        py={8}
      >
        <Text
          color={textColor}
          fontWeight={"bold"}
          fontSize={{
            lg: 19,
            xl: 22,
          }}
          textAlign={"center"}
          position="absolute"
          opacity={onHover ? 0 : 1}
          visibility={onHover ? "hidden" : "visible"}
          transform={onHover ? "translateY(-10px)" : "translateY(0)"}
          transition={
            "opacity 0.3s ease-in-out, visibility 0s linear 0.3s, transform 0.3s ease-in-out"
          }
        >
          {label}
        </Text>
        <Text
          color={textColor}
          px={3}
          py={6}
          textAlign={"center"}
          fontSize={{
            lg: 16,
            xl: 18,
          }}
          opacity={onHover ? 1 : 0}
          visibility={onHover ? "visible" : "hidden"}
          transform={onHover ? "translateY(0)" : "translateY(10px)"}
          transition={
            "opacity 0.3s ease-in-out, visibility 0s linear 0.3s, transform 0.3s ease-in-out"
          }
        >
          {description}
        </Text>
      </Flex>
    </Card>
  );
};
